if (!customElements.get('parallax-gallery')) {
  customElements.define(
    'parallax-gallery',
    class ParallaxGallery extends HTMLElement {
      constructor() {
        super();
        this.requestUpdate = this.requestUpdate.bind(this);
        this.isVisible = false;
        this.ticking = false;
      }

      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-parallax-speed]'));
        if (this.items.length === 0) return;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: no-preference) and (min-width: 750px)');

        this.observer = new IntersectionObserver(([entry]) => {
          this.isVisible = entry.isIntersecting;
          if (this.isVisible) this.requestUpdate();
        });
        this.observer.observe(this);

        window.addEventListener('scroll', this.requestUpdate, { passive: true });
        window.addEventListener('resize', this.requestUpdate);
        this.motionQuery.addEventListener('change', this.requestUpdate);
      }

      disconnectedCallback() {
        if (!this.observer) return;
        this.observer.disconnect();
        window.removeEventListener('scroll', this.requestUpdate);
        window.removeEventListener('resize', this.requestUpdate);
        this.motionQuery.removeEventListener('change', this.requestUpdate);
      }

      requestUpdate() {
        if (this.ticking || !this.isVisible) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      update() {
        if (!this.motionQuery.matches) {
          this.items.forEach((item) => item.style.removeProperty('--parallax-offset'));
          return;
        }

        // Measure the gallery rather than the items, since the items are the ones being moved.
        const rect = this.getBoundingClientRect();
        const distanceFromCenter = rect.top + rect.height / 2 - window.innerHeight / 2;

        this.items.forEach((item) => {
          const offset = distanceFromCenter * parseFloat(item.dataset.parallaxSpeed);
          item.style.setProperty('--parallax-offset', `${offset.toFixed(1)}px`);
        });
      }
    }
  );
}
